import { useStore } from 'utils/hooks/store';

import { EntityModules } from 'core/constants';

import { getEntityTranslation, Translation } from 'stores/EntityDetails/utils';
import { EntitiesStores } from 'components/Entities/types';

type RelatedEntityDetailsProps = {
  store: EntitiesStores;
  translations: Translation;
  nameKey: string;
  entityType: EntityModules;
};

type BasicValuesProps = Record<EntityModules, Omit<RelatedEntityDetailsProps, 'store'>>;

export const basicValues: BasicValuesProps = Object.fromEntries(
  Object.values(EntityModules).map((module) => [
    module,
    {
      translations: getEntityTranslation[module],
      nameKey: `${module}__name`,
      entityType: module,
    },
  ])
) as BasicValuesProps;

export const getRelatedEntityDetails = (url: string): RelatedEntityDetailsProps => {
  const module = url.split('/')[1] as EntityModules;
  const stores = useStore();

  switch (module) {
    case EntityModules.Sites:
      return { store: stores.siteDetails, ...basicValues[EntityModules.Sites] };
    case EntityModules.Assets:
      return { store: stores.assetDetails, ...basicValues[EntityModules.Assets] };
    case EntityModules.Contacts:
      return { store: stores.contactDetails, ...basicValues[EntityModules.Contacts] };
    case EntityModules.Events:
      return { store: stores.eventDetails, ...basicValues[EntityModules.Events] };
    case EntityModules.RisksAssessments:
      return { store: stores.riskAssessmentDetails, ...basicValues[EntityModules.RisksAssessments] };
    case EntityModules.Documents:
      return { store: stores.documentsDetails, ...basicValues[EntityModules.Documents] };
    case EntityModules.Risks:
      return { store: stores.riskDetails, ...basicValues[EntityModules.Risks] };
    case EntityModules.Audits:
      return { store: stores.auditRecord, ...basicValues[EntityModules.Audits] };
    case EntityModules.Controls:
      return { store: stores.controlDetails, ...basicValues[EntityModules.Controls] };
    case EntityModules.Hazards:
      return { store: stores.hazardDetails, ...basicValues[EntityModules.Hazards] };
    default:
      return { store: stores.siteDetails, ...basicValues[EntityModules.Sites] };
  }
};
